if (!customElements.get('customer-reviews-v2')) {
  class CustomerReviews extends HTMLElement {
    constructor() {
      super();
      this._swiperContainer = null;
      this._swiperInstance = null;
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this._swiperContainer = this.querySelector('.swiper');
        this.initializeSwiper();
      });
    }

    initializeSwiper() {
      if (!this._swiperContainer) {
        console.error('Swiper container not found');
        return;
      }

      const nextButton = this.querySelector('.swiper-btn-next');
      const prevButton = this.querySelector('.swiper-btn-prev');
      const pagination = this.querySelector(`.swiper-pagination`);

      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        watchSlidesVisibility: true,
        watchOverflow: true,
        direction: "horizontal",
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
      });
    }
  }

  customElements.define('customer-reviews-v2', CustomerReviews);
}